import { createActionWithPayload } from './utils';

export const ACTIONS = {
  UPDATE_TEACHER_AV_STATE: 'UPDATE_TEACHER_AV_STATE',
} as const;

export const updateTeacherAVState = createActionWithPayload<
  typeof ACTIONS.UPDATE_TEACHER_AV_STATE,
  {
    teacherClassroomId: string;
    activeStudentId?: string;
    onMute: boolean;
    onHold: boolean;
  }
>(ACTIONS.UPDATE_TEACHER_AV_STATE);
